import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';
import moment from 'moment';

@Component({
  selector: 'app-document-form-notif-delai-urssaf',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-notif-delai-urssaf.component.html',
  styleUrl: './document-form-notif-delai-urssaf.component.scss',
})
export class DocumentFormNotifDelaiUrssafComponent extends DocumentFormBase<NotifDelaiUrssafForm> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createNotifDelaiUrssafForm(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      const dateFinNotifDelaiUrssaf = moment(newDate).add(6, 'months').toDate();
      const newDateFin = newDate ? dateFinNotifDelaiUrssaf : undefined;

      this.form.get('dateFinValidite')?.setValue(newDateFin);
    }
  }
}

export function createNotifDelaiUrssafForm(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type NotifDelaiUrssafForm = ReturnType<typeof createNotifDelaiUrssafForm>;
export type NotifDelaiUrssafFormValue = NotifDelaiUrssafForm['value'];
